import { render, staticRenderFns } from "./PaymentAndInvoicingReportTable.vue?vue&type=template&id=b87b6a6c&scoped=true&"
import script from "./PaymentAndInvoicingReportTable.vue?vue&type=script&lang=js&"
export * from "./PaymentAndInvoicingReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87b6a6c",
  null
  
)

export default component.exports